import { render, staticRenderFns } from "./MyPageTop.vue?vue&type=template&id=0b5cec68&scoped=true&"
import script from "./MyPageTop.vue?vue&type=script&lang=js&"
export * from "./MyPageTop.vue?vue&type=script&lang=js&"
import style0 from "./MyPageTop.vue?vue&type=style&index=0&id=0b5cec68&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b5cec68",
  null
  
)

export default component.exports